import axios from 'axios'
const couchDB = axios.create({
  baseURL: 'https://c4fitness.lk:4984',
  auth: {
    username: 'admin',
    password: 'c4@123',
  },
})

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async markAttendance({ commit, state }, { attendanceDetails }) {
    const response = await couchDB.post('/c4_db', attendanceDetails)
    return response.data
  },
  async checkForAttendance({ commit, state }, query) {
    const response = await couchDB.post('/c4_db/_find', query)
    return response.data
  },
}
